import React from "react"
import RenderRoutes from "./renderRoutes"
import routes from "./routes"
import { withRouter } from "react-router-dom"
// export { renderRoutes, routes }

const MyRoutes = () => {
  return <RenderRoutes routes={routes()} />
}

export default withRouter(MyRoutes)
